export interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  author: string;
  authorAvatar: string;
  thumbnail: string;
  duration: string;
  views: number;
  likes: number;
  date: string;
  tags: string[];
  content: string;
}

export const videos: Video[] = [
  {
    id: 'v001',
    title: '清晨五点起床的日常 | 慢生活治愈系Vlog',
    description: '记录一个普通上班族清晨五点起床的日常生活，从晨间拉伸到自制早餐，从通勤路上到办公室打卡，用镜头捕捉平凡日子里的温暖瞬间。在这个快节奏的都市生活中，五分钟的宁静也许就是最好的治愈。本视频采用自然光线拍摄，配以轻柔的背景音乐，希望给观众带来一份内心的平静与力量。',
    category: 'life-record',
    author: '小鹿生活记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20woman%20portrait%20avatar%20with%20warm%20smile%2C%20simple%20white%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%2C%20casual%20style%2C%20friendly%20expression&width=100&height=100&seq=author-v001&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20morning%20routine%20in%20a%20bright%20modern%20Chinese%20apartment%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20person%20making%20breakfast%20in%20a%20minimalist%20kitchen%2C%20soft%20natural%20lighting%2C%20peaceful%20atmosphere%2C%20lifestyle%20photography%20with%20clean%20warm%20tones%2C%20cozy%20home%20vibe%2C%20simple%20white%20and%20wood%20interior%2C%20gentle%20morning%20light&width=800&height=450&seq=thumb-v001&orientation=landscape',
    duration: '05:23',
    views: 128000,
    likes: 8900,
    date: '2026-08-01',
    tags: ['慢生活', '日常vlog', '治愈系', '早起'],
    content: '清晨五点的闹钟准时响起，窗外天色微亮。我轻手轻脚地起床，不想打扰还在熟睡的室友。先做十五分钟的晨间拉伸，让身体慢慢苏醒。然后走进厨房，今天打算做一个简单的牛油果吐司配一杯手冲咖啡。阳光透过百叶窗在料理台上洒下斑驳的光影，这一刻的宁静是我一天中最享受的时光。',
  },
  {
    id: 'v002',
    title: '一个人的重庆之旅 | 山城三日暴走攻略',
    description: '一个人背包走重庆，三天两夜打卡洪崖洞、解放碑、长江索道、南山一棵树等经典景点。全程自拍视角记录旅途中的风景与心情，分享实用旅行攻略和隐藏美食推荐，让你也能轻松玩转山城重庆。',
    category: 'travel-vlog',
    author: '行走的阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20avatar%2C%20outdoor%20travel%20style%2C%20casual%20hat%20and%20backpack%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20adventurous%20vibe&width=100&height=100&seq=author-v002&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20night%20view%20of%20Chongqing%20Hongyadong%20with%20golden%20lights%20reflecting%20on%20the%20Jialing%20River%2C%20traditional%20stilted%20buildings%20illuminated%20against%20the%20modern%20city%20skyline%2C%20warm%20golden%20and%20amber%20tones%2C%20travel%20photography%2C%20dramatic%20cityscape%20with%20bridges%20and%20skyscrapers%2C%20vibrant%20night%20atmosphere&width=800&height=450&seq=thumb-v002&orientation=landscape',
    duration: '12:45',
    views: 356000,
    likes: 23400,
    date: '2026-07-28',
    tags: ['重庆', '旅行攻略', '独自旅行', '山城'],
    content: '重庆是一座来了就不想走的城市。第一站选择了洪崖洞，傍晚时分华灯初上，整片吊脚楼建筑群像悬浮在嘉陵江上的宫殿。从千厮门大桥上望过去，那种震撼难以用语言形容。第二天去了长江索道，排队半小时终于坐上了传说中的"空中巴士"。',
  },
  {
    id: 'v003',
    title: '藏在巷子里的老火锅 | 重庆本地人私藏推荐',
    description: '跟着重庆本地朋友探访藏在深巷里的三十年老火锅店，环境简陋但味道绝了！毛肚七上八下、鸭血嫩滑入味、现炸酥肉外酥里嫩，每一口都是地道重庆味。人均不到一百吃到撑，这才是真正的市井美食。',
    category: 'food-explore',
    author: '饭饭而谈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20food%20blogger%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20casual%20look%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20and%20energetic%20expression&width=100&height=100&seq=author-v003&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20hotpot%20in%20a%20rustic%20alleyway%20restaurant%20with%20steaming%20red%20broth%2C%20fresh%20ingredients%20on%20wooden%20table%2C%20chopsticks%20dipping%20meat%2C%20warm%20cozy%20atmosphere%20with%20red%20lanterns%2C%20authentic%20Chongqing%20style%2C%20food%20photography%20with%20rich%20colors%20and%20steam%2C%20simple%20background%2C%20mouthwatering%20texture&width=800&height=450&seq=thumb-v003&orientation=landscape',
    duration: '08:12',
    views: 289000,
    likes: 18700,
    date: '2026-07-25',
    tags: ['美食探店', '重庆火锅', '街头美食', '老店'],
    content: '这家店真的太难找了！跟着导航在巷子里拐了七八个弯才找到。门口没有招牌，只有一口冒着热气的大锅和排队的人群。老板说他们家的底料是祖传配方，用了三十多种香料慢熬八小时。锅底端上来的一瞬间，那股麻辣鲜香的味道直接把我征服了。',
  },
  {
    id: 'v004',
    title: '一键换装创意短片 | 30套穿搭挑战',
    description: '用转场拍摄手法挑战30套不同风格穿搭的一键换装创意短片，从校园风到职场风，从街头潮流到国风汉服，每一套都精心搭配。剪辑节奏紧凑，画面流畅，看完秒变穿搭达人。',
    category: 'fashion-beauty',
    author: '穿搭小天才',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Chinese%20woman%20portrait%20avatar%2C%20stylish%20outfit%2C%20confident%20smile%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20modern%20fashion%20vibe&width=100&height=100&seq=author-v004&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20fashion%20outfit%20change%20montage%20with%20multiple%20stylish%20looks%20in%20a%20clean%20modern%20studio%20setting%2C%20colorful%20clothing%20displayed%20on%20racks%2C%20warm%20neutral%20background%2C%20fashion%20photography%20with%20soft%20lighting%2C%20creative%20composition%2C%20trendy%20Chinese%20street%20fashion%20aesthetic&width=800&height=450&seq=thumb-v004&orientation=landscape',
    duration: '03:45',
    views: 567000,
    likes: 45100,
    date: '2026-07-22',
    tags: ['时尚穿搭', '创意短片', '换装挑战', '国风'],
    content: '一直想做一个一键换装的创意短片，这次终于实现了！准备了整整两天，搭配了30套不同风格的穿搭。拍摄技巧其实很简单，固定机位不变，每次换装后回到同一个位置做一个固定的动作，后期通过剪辑把动作衔接起来就行了。最难的是每套衣服的搭配和妆容变化。',
  },
  {
    id: 'v005',
    title: '我的第一台微单开箱 | Sony A7C II 真实体验',
    description: '入手了心心念念的Sony A7C II全画幅微单相机，从开箱到上手体验全记录。分享为什么选择这台相机、与手机拍摄的对比、以及新手入门摄影的一些小建议。用这台新相机拍的第一组样片也放在视频里了。',
    category: 'tech-digital',
    author: '数码老司机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20reviewer%20man%20portrait%20avatar%2C%20geeky%20but%20friendly%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20smart%20casual%20look&width=100&height=100&seq=author-v005&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sony%20A7C%20II%20mirrorless%20camera%20unboxing%20on%20a%20clean%20wooden%20desk%20with%20warm%20natural%20light%2C%20camera%20lens%20and%20accessories%20neatly%20arranged%2C%20product%20photography%20style%20with%20soft%20shadows%2C%20minimalist%20setup%2C%20warm%20amber%20tones%2C%20professional%20tech%20aesthetic&width=800&height=450&seq=thumb-v005&orientation=landscape',
    duration: '10:28',
    views: 198000,
    likes: 12300,
    date: '2026-07-20',
    tags: ['数码测评', '微单相机', '开箱', '摄影入门'],
    content: '终于等到索尼A7C II降价了，纠结了三个月还是剁手了。开箱那一刻真的激动到手抖，比想象中还要小巧轻便。全画幅传感器的画质确实和手机不是一个级别的，尤其是暗光环境下的表现。用套机镜头拍了几张，虚化效果非常自然。',
  },
  {
    id: 'v006',
    title: '两只金毛的快乐一天 | 铲屎官崩溃日常',
    description: '记录我家两只金毛犬从早到晚的快乐生活，早上六点叫醒服务、公园狂奔、泥坑打滚、偷吃零食被抓包、洗澡时的大型灾难现场。虽然每天都累到崩溃，但是看到它们开心的样子一切都值了。',
    category: 'pet-cute',
    author: '金毛两兄弟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20golden%20retriever%20dog%20portrait%20avatar%2C%20happy%20expression%2C%20warm%20lighting%2C%20clean%20background%2C%20pet%20photography&width=100&height=100&seq=author-v006&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20adorable%20golden%20retrievers%20playing%20happily%20in%20a%20sunny%20green%20park%20with%20warm%20golden%20sunlight%2C%20dogs%20running%20and%20jumping%20with%20joy%2C%20beautiful%20natural%20outdoor%20setting%20with%20trees%20and%20grass%2C%20pet%20photography%20with%20soft%20bokeh%20background%2C%20warm%20and%20cheerful%20atmosphere&width=800&height=450&seq=thumb-v006&orientation=landscape',
    duration: '06:55',
    views: 445000,
    likes: 38700,
    date: '2026-07-18',
    tags: ['萌宠', '金毛', '狗狗日常', '治愈'],
    content: '养两只金毛是什么体验？两个字：崩溃。三个字：非常崩溃。每天早上六点准时被舔醒，想睡懒觉是不可能的。今天带它们去公园，大毛在草地上跑了两圈就一头扎进了泥坑里，二毛也不甘示弱跟着跳进去。两只泥猴就这样在公园里狂奔。',
  },
  {
    id: 'v007',
    title: '零基础健身入门 | 居家30天蜕变计划',
    description: '完全零基础也能上手的居家健身计划，每天只需二十分钟，坚持三十天就能看到明显变化。全程自拍跟练模式，详细讲解每个动作要领和常见错误，无需任何器械，一张瑜伽垫就能开始你的健身之旅。',
    category: 'fitness-sport',
    author: '铁蛋健身',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fitness%20coach%20young%20Chinese%20man%20portrait%20avatar%2C%20athletic%20build%2C%20motivational%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20sporty%20style&width=100&height=100&seq=author-v007&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Home%20workout%20scene%20in%20a%20bright%20modern%20living%20room%20with%20yoga%20mat%20on%20wooden%20floor%2C%20person%20doing%20plank%20exercise%2C%20warm%20natural%20sunlight%2C%20minimalist%20interior%20design%2C%20fitness%20lifestyle%20photography%2C%20clean%20and%20motivating%20atmosphere%2C%20soft%20neutral%20tones&width=800&height=450&seq=thumb-v007&orientation=landscape',
    duration: '15:20',
    views: 312000,
    likes: 22100,
    date: '2026-07-15',
    tags: ['居家健身', '零基础', '30天计划', '减肥'],
    content: '很多人问我零基础怎么开始健身，今天就出这个30天居家健身计划。不需要任何器械，不需要去健身房，每天只要二十分钟。关键不在于动作多难，而在于你能坚持多久。第一个动作从平板支撑开始，目标不是时间长短，而是姿势标准。',
  },
  {
    id: 'v008',
    title: '一台手机拍出电影感 | 手机摄影全攻略',
    description: '不买相机也能拍出高级视频！分享手机拍摄的构图技巧、光线运用、稳定器使用以及后期剪辑全流程。用一台普通的手机拍出了旅行短片，画面质感完全不输专业设备，关键是掌握这些技巧。',
    category: 'creative-short',
    author: '视觉玩家阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Creative%20young%20Chinese%20man%20portrait%20avatar%2C%20artistic%20style%2C%20holding%20camera%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20cinematographer%20vibe&width=100&height=100&seq=author-v008&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20smartphone%20filmmaking%20setup%20on%20a%20wooden%20desk%20with%20phone%20gimbal%20stabilizer%2C%20warm%20golden%20hour%20light%20streaming%20in%2C%20creative%20workspace%20with%20storyboard%20and%20equipment%2C%20filmmaking%20aesthetic%2C%20soft%20natural%20lighting%2C%20artistic%20composition%2C%20warm%20and%20inspiring%20atmosphere&width=800&height=450&seq=thumb-v008&orientation=landscape',
    duration: '09:30',
    views: 423000,
    likes: 32100,
    date: '2026-07-12',
    tags: ['手机摄影', '拍摄技巧', '创意短片', '构图'],
    content: '很多人觉得拍出电影感必须用专业设备，其实一台手机就够了。今天教大家几个我一直在用的技巧。首先是构图的黄金法则——三分法，把主体放在画面三分之一的位置。其次是光线，黄金时间的光线是最美的，早上和傍晚一定要抓住。',
  },
  {
    id: 'v009',
    title: '打工人的周日时光 | 一个人也要好好生活',
    description: '一个普通打工人的周日生活记录，睡到自然醒、逛菜市场、给自己做一顿丰盛的午餐、午后读书、晚上泡个热水澡。没有宏大的主题，只有对生活最真实的记录和热爱。看完你会发现，原来一个人的日子也可以过得这样充实。',
    category: 'life-record',
    author: '小鹿生活记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20young%20Chinese%20woman%20portrait%20avatar%20with%20warm%20smile%2C%20simple%20white%20background%2C%20soft%20natural%20lighting%2C%20professional%20headshot%2C%20casual%20style%2C%20friendly%20expression&width=100&height=100&seq=author-v001&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Relaxing%20Sunday%20afternoon%20in%20a%20bright%20cozy%20Chinese%20apartment%2C%20person%20reading%20book%20on%20a%20comfortable%20sofa%20by%20the%20window%2C%20warm%20sunlight%20and%20indoor%20plants%2C%20minimalist%20lifestyle%20photography%2C%20peaceful%20atmosphere%2C%20soft%20neutral%20tones%2C%20cozy%20home%20interior&width=800&height=450&seq=thumb-v009&orientation=landscape',
    duration: '07:48',
    views: 198000,
    likes: 14300,
    date: '2026-07-10',
    tags: ['周日vlog', '独居生活', '治愈', '日常'],
    content: '周日早上不用设闹钟的感觉太好了。睡到九点半自然醒，拉开窗帘阳光洒进来，给阳台上的绿萝浇了水。然后骑共享单车去附近最大的菜市场，买了新鲜的大虾和蔬菜，花了不到六十块。中午做了一道蒜蓉大虾和清炒时蔬。',
  },
  {
    id: 'v010',
    title: '大理环洱海骑行 | 最美公路全记录',
    description: '租了一辆小电驴从大理古城出发，沿着洱海环湖骑行一整天。沿途经过喜洲古镇、双廊、挖色、小普陀，记录下了洱海最美的七十二公里。蓝天白云下的苍山洱海，每一帧都像明信片。',
    category: 'travel-vlog',
    author: '行走的阿明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20avatar%2C%20outdoor%20travel%20style%2C%20casual%20hat%20and%20backpack%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20adventurous%20vibe&width=100&height=100&seq=author-v002&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Erhai%20Lake%20in%20Dali%20Yunnan%20with%20Cangshan%20mountains%20in%20background%2C%20scooter%20riding%20along%20scenic%20lakeside%20road%2C%20clear%20blue%20sky%20with%20white%20clouds%2C%20travel%20photography%20with%20warm%20sunlight%2C%20peaceful%20natural%20scenery%2C%20traditional%20white%20architecture%20visible%20in%20distance&width=800&height=450&seq=thumb-v010&orientation=landscape',
    duration: '18:35',
    views: 489000,
    likes: 34100,
    date: '2026-07-08',
    tags: ['大理', '洱海骑行', '云南旅行', '自驾游'],
    content: '来大理一定要环洱海！花六十块租了一辆续航一百二十公里的小电驴，从古城出发逆时针环湖。第一站是喜洲古镇，白族建筑的白墙青瓦在阳光下特别好看。转角遇到了一家卖喜洲粑粑的老店，刚出炉的甜味粑粑外酥里软。',
  },
  {
    id: 'v011',
    title: '广州早茶探店 | 人均50吃到扶墙出',
    description: '打卡广州三家本地人最爱去的早茶老店，从虾饺烧卖到凤爪排骨，从肠粉到蛋挞，一口气吃了二十几种点心。告诉你哪些必点哪些踩雷，还有隐藏的省钱小技巧。看完这个视频去广州再也不怕吃早茶被坑了。',
    category: 'food-explore',
    author: '饭饭而谈',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20food%20blogger%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20casual%20look%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20and%20energetic%20expression&width=100&height=100&seq=author-v003&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Guangzhou%20dim%20sum%20spread%20on%20a%20round%20table%20with%20bamboo%20steamers%2C%20various%20colorful%20dim%20sum%20dishes%2C%20Chinese%20tea%20being%20poured%2C%20warm%20restaurant%20atmosphere%20with%20red%20lanterns%2C%20food%20photography%20with%20rich%20details%2C%20authentic%20Cantonese%20cuisine%20style&width=800&height=450&seq=thumb-v011&orientation=landscape',
    duration: '11:20',
    views: 378000,
    likes: 25400,
    date: '2026-07-05',
    tags: ['广州早茶', '美食探店', '点心', '粤菜'],
    content: '来广州不吃早茶等于白来！今天带大家去三家本地人心目中的宝藏早茶店。第一家是老城区的百年老店，虾饺皮薄如蝉翼，里面的虾仁新鲜弹牙。第二家以创新点心著称，黑松露烧卖绝了。第三家性价比超高，人均不到五十。',
  },
  {
    id: 'v012',
    title: '用AI做动画短片 | 零基础三天出片',
    description: '不会画画也能做动画？借助最新的AI工具，从剧本创作到角色设计，从场景搭建到成片渲染，三天完成一部三分钟的原创动画短片。全程记录创作过程，分享AI动画工具的使用技巧和避坑指南。',
    category: 'creative-short',
    author: '视觉玩家阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Creative%20young%20Chinese%20man%20portrait%20avatar%2C%20artistic%20style%2C%20holding%20camera%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20cinematographer%20vibe&width=100&height=100&seq=author-v008&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20computer%20screen%20showing%20AI%20animation%20creation%20process%2C%20colorful%20storyboard%20sketches%20on%20desk%2C%20warm%20modern%20studio%20lighting%2C%20digital%20art%20creation%20atmosphere%2C%20creative%20technology%20aesthetic%2C%20inspiring%20workspace%20with%20plants%20and%20art%20supplies&width=800&height=450&seq=thumb-v012&orientation=landscape',
    duration: '08:50',
    views: 534000,
    likes: 41200,
    date: '2026-07-02',
    tags: ['AI动画', '创意制作', '短视频', 'AI工具'],
    content: '现在的AI工具真的太强了，不会画画也能做动画！先用ChatGPT帮我写了一个科幻短片的剧本，然后用Midjourney生成了角色设计图。关键是要保持角色的一致性，这里有个小技巧——在提示词里加入特定的角色描述关键词。',
  },
  {
    id: 'v013',
    title: '春季日常妆容教程 | 十分钟出门妆',
    description: '超级适合上班上学族的春季日常妆容教程，清透底妆加元气腮红加温柔的奶茶色口红，整个妆容不超过十分钟就能完成。全程高清特写镜头，新手也能跟着学会。春天就要这种清新自然的感觉。',
    category: 'fashion-beauty',
    author: '穿搭小天才',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fashionable%20young%20Chinese%20woman%20portrait%20avatar%2C%20stylish%20outfit%2C%20confident%20smile%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20modern%20fashion%20vibe&width=100&height=100&seq=author-v004&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Makeup%20tutorial%20setup%20with%20various%20cosmetics%20and%20brushes%20neatly%20arranged%20on%20a%20white%20vanity%20desk%2C%20soft%20natural%20morning%20light%2C%20spring%20fresh%20color%20palette%20with%20pink%20and%20peach%20tones%2C%20beauty%20photography%20with%20clean%20aesthetic%2C%20feminine%20and%20elegant%20vibe&width=800&height=450&seq=thumb-v013&orientation=landscape',
    duration: '06:40',
    views: 423000,
    likes: 33100,
    date: '2026-06-30',
    tags: ['美妆教程', '日常妆容', '春季', '新手友好'],
    content: '春夏天最怕妆感太重，今天教大家一个清透到像没化妆的日常妆容。底妆只用了气垫和一点点遮瑕，重点是让皮肤看起来透亮而不是厚重。腮红选择了杏粉色，打在苹果肌上立刻元气满满。口红是奶茶色，日常又温柔。',
  },
  {
    id: 'v014',
    title: '两只猫的战争 | 新猫到家第一天',
    description: '家里迎来了新成员——一只三花小奶猫，但是原住民橘猫好像不太欢迎它。记录两只猫从见面互相哈气到慢慢接受对方的全过程，中间发生了不少搞笑的瞬间。养猫的人一定深有体会。',
    category: 'pet-cute',
    author: '金毛两兄弟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Cute%20golden%20retriever%20dog%20portrait%20avatar%2C%20happy%20expression%2C%20warm%20lighting%2C%20clean%20background%2C%20pet%20photography&width=100&height=100&seq=author-v006&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20cats%20an%20orange%20tabby%20and%20a%20small%20calico%20kitten%20sitting%20on%20opposite%20sides%20of%20a%20cozy%20living%20room%2C%20warm%20sunlight%20through%20window%2C%20curious%20and%20cautious%20expressions%2C%20pet%20photography%20with%20soft%20bokeh%2C%20cute%20and%20funny%20atmosphere%2C%20minimalist%20home%20interior&width=800&height=450&seq=thumb-v014&orientation=landscape',
    duration: '05:15',
    views: 567000,
    likes: 48900,
    date: '2026-06-28',
    tags: ['猫咪', '新宠到家', '搞笑', '萌宠'],
    content: '一直想再养一只猫陪橘子，终于下定决心领养了一只小三花。但是橘子看到新来的小家伙时，那个表情真的太好笑了——先是一脸震惊，然后开始疯狂哈气。小三花倒是胆子大，完全不怕，还想凑过去闻橘子。',
  },
  {
    id: 'v015',
    title: 'iPad Pro 2026深度测评 | 值得升级吗',
    description: '第一时间拿到了新款iPad Pro 2026，与上一代做了详细对比。屏幕、性能、续航、配件兼容性全方位测试，告诉你哪些升级是实实在在的提升，哪些是可有可无的噱头。看完再决定要不要升级。',
    category: 'tech-digital',
    author: '数码老司机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20tech%20reviewer%20man%20portrait%20avatar%2C%20geeky%20but%20friendly%20style%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20smart%20casual%20look&width=100&height=100&seq=author-v005&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=iPad%20Pro%202026%20on%20a%20clean%20minimalist%20desk%20with%20Apple%20Pencil%20and%20Magic%20Keyboard%2C%20professional%20product%20photography%20with%20soft%20studio%20lighting%2C%20warm%20neutral%20background%2C%20tech%20review%20aesthetic%2C%20crisp%20and%20clean%20composition&width=800&height=450&seq=thumb-v015&orientation=landscape',
    duration: '14:10',
    views: 287000,
    likes: 18700,
    date: '2026-06-25',
    tags: ['iPad Pro', '数码测评', '苹果', '平板电脑'],
    content: 'iPad Pro 2026终于到了，包装还是一如既往的简洁。最大的升级是这块屏幕，亮度提升明显，户外使用终于不用遮遮掩掩了。M4芯片的性能提升在日常使用中感知不强，但在视频剪辑和3D渲染时差距就出来了。',
  },
  {
    id: 'v016',
    title: '帕梅拉15分钟燃脂 | 暴汗挑战',
    description: '挑战帕梅拉最火的15分钟全身燃脂训练，全程跟练无剪辑。从热身到爆汗到拉伸，真实记录每一个动作的感受。说实话中间好几次想放弃，但坚持到最后的感觉真的太爽了。新手谨慎尝试，老手请直接上车。',
    category: 'fitness-sport',
    author: '铁蛋健身',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Fitness%20coach%20young%20Chinese%20man%20portrait%20avatar%2C%20athletic%20build%2C%20motivational%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20sporty%20style&width=100&height=100&seq=author-v007&orientation=squarish',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intense%20home%20HIIT%20workout%20scene%20with%20person%20doing%20burpees%20on%20a%20yoga%20mat%2C%20sweat%20and%20determination%2C%20bright%20natural%20light%20from%20large%20window%2C%20minimalist%20home%20gym%20setting%2C%20fitness%20photography%20with%20dynamic%20energy%2C%20motivational%20atmosphere&width=800&height=450&seq=thumb-v016&orientation=landscape',
    duration: '16:30',
    views: 345000,
    likes: 26700,
    date: '2026-06-22',
    tags: ['燃脂运动', 'HIIT', '帕梅拉', '暴汗'],
    content: '帕梅拉这套15分钟燃脂训练真的名不虚传。才做了五分钟就开始暴汗，十分钟的时候腿已经开始发抖。里面的波比跳和高抬腿是最要命的，但也是最有效的。建议大家根据自己的体能情况适当调整节奏。',
  },
];

export function getVideosByCategory(slug: string): Video[] {
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: string): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function getFeaturedVideos(): Video[] {
  return videos.slice(0, 8);
}

export function getRelatedVideos(id: string, category: string): Video[] {
  return videos.filter((v) => v.id !== id && v.category === category).slice(0, 4);
}